import { Spinner } from '@schibsted-svp/react-ui';

import type { FC } from 'react';

import styles from './CenteredSpinner.module.scss';

type Props = {
  size?: 'small' | 'big';
};

const CenteredSpinner: FC<Props> = ({ size }) => {
  return (
    <div className={styles.container}>
      <Spinner size={size} />
    </div>
  );
};

export { CenteredSpinner };
